import Link from '@/components/Link';

export default function PostBreadcrumb({ categories }) {
  return (
    <div className="text-lg lg:text-xl">
      <Link
        href="/blog"
        className="font-semibold text-green-500 hover:text-green-600 inline-flex items-center -ml-4"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
        <span>Blog</span>
      </Link>
      <div className="flex items-center space-x-2 -ml-2 mt-1 md:mt-2">
        <div className="text-gray-300 font-bold">/</div>
        <div className="text-base lg:text-lg font-semibold text-gray-900">
          {categories.map(({ slug, name, uri }) => (
            <Link key={slug} href={uri}>
              {name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
